import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import { PostEventProps, SoloPlayer, TeamPlayer } from '../EventTypes'
import FlagImage from '../../../BaseComponents/Image/Flag'
import PlayerImage from '../../../BaseComponents/Image/Player'
import HighlightRow from '../../HighlightRow'
import PostEventRowOptionalField from './HelperClass/OptionalField'

const PostEventRow: FC<PostEventProps> = ({
    paddingTop = 4,
    borderRadius,
    playersProp,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText,
}) => (
    <Grid noExpand borderRadius={borderRadius} backgroundColor="pearl">
        {playersProp.map(
            (
                {
                    onPressEvent,
                    caption,
                    playerName,
                    playerImage,
                    winTime,
                    position,
                    teamProps,
                }: SoloPlayer | TeamPlayer,
                index: number
            ) => (
                <Grid
                    paddingX={5}
                    paddingTop={index === 0 ? paddingTop : 4}
                    paddingBottom={4}
                    borderBottom={position === 3 ? undefined : '1px'}
                    borderColor="tahitian-4"
                    key={`POSTEVENT_${index}`}
                >
                    <Touchable onPress={onPressEvent} expand>
                        <Grid horizontal centerVertical>
                            <Grid noExpand width={20}>
                                <SmallBodyFont
                                    textAlign="right"
                                    bold
                                >{`${position}.`}</SmallBodyFont>
                            </Grid>
                            <Grid noExpand width={44} centerHorizontal>
                                {teamProps ? (
                                    <PlayerImage size="S" width={24} imageUrl={playerImage} />
                                ) : (
                                    <FlagImage size="S" width={20} imageUrl={playerImage} />
                                )}
                            </Grid>
                            <Grid expand minWidth={0}>
                                <SmallBodyFont numberOfLines={1} bold={position === 1} color="onyx">
                                    {playerName}
                                </SmallBodyFont>
                            </Grid>
                            <SmallBodyFont numberOfLines={1} bold={position === 1}>
                                {winTime}
                            </SmallBodyFont>
                        </Grid>
                        <PostEventRowOptionalField caption={caption} teamProps={teamProps} />
                    </Touchable>
                </Grid>
            )
        )}
        {onPressVideoButton || videoButtonHref ? (
            <HighlightRow
                text={videoButtonText}
                onPress={onPressVideoButton}
                href={videoButtonHref}
                marginBottom={4}
            />
        ) : null}
    </Grid>
)

export default PostEventRow
